import { get } from "lodash";
import { aggregatePath, trackPageView } from 'utils/mrTracker.ts';

async function sha256(message) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder('utf-8').encode(message);

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string
    return hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');
}
export async function getUserIdForGoogleAnalytics(userId) {
    //For users with federated identity, encrypt their username to not have plain user data in Google analytics.
    //crypto.subtle API is not available on unsecured locations, such as developing on local machines, so in
    //these cases we just use 'developer-local' as user id.
    if (!crypto.subtle) {
        return 'developer-local';
    } else if (userId.startsWith('auth0')) {
        return userId;
    } else {
        return sha256(userId);
    }
}
export const setGoogleAnalytics = authResult => {
    const tagId = import.meta.env.VITE_GOOGLE_ANALYTICS_TAG;
    const idTokenPayload = authResult.idTokenPayload;

    if (idTokenPayload) {
        getUserIdForGoogleAnalytics(idTokenPayload.sub)
          .then(userId => {
              window.gtag('set', {'user_id': userId});
          });

        //Internal account taken from auth0
        const disableGAForInternalAccounts = ['NetAppTest', 'NetAppCourse', 'NetAppDemo'];
        const idTokenPayloadInternal = idTokenPayload['http://cloud.netapp.com/internal'];
        if (disableGAForInternalAccounts.includes(idTokenPayloadInternal)) {
            console.log(`Analytics Disabled for ${idTokenPayloadInternal} Account`);
            window[`ga-disable-${tagId}`] = true;
        } else {
            window.gtag('config', tagId, {
                'page_location': window.origin + aggregatePath({location: window.location}),
                'send_page_view': false
            });
            if (idTokenPayloadInternal === 'NetApp') {
                //verified netapp email or netapp federation
                //federations: NetAppSAML || TestSamlConn || netapp-waad || azuread || BlueXP-Federation;
                window.gtag('set', 'user_properties', {internalUser: 'YES'});
            } else {
                const email = idTokenPayload.email ||
                  _.get(authResult, 'idTokenPayload["http://cloud.netapp.com/user_metadata"].email');
                if (email && email.endsWith('@netapp.com')) {
                    //unverified netapp email
                    window.gtag('set', 'user_properties', {internalUser: 'UNKNOWN'});
                }
                else {
                    window.gtag('set', 'user_properties', {internalUser: 'NO'});
                }
            }
        }
    }
};

export const setGaAccount = (accountId) => {
    window.gtag('set', 'user_properties', {accountIdentity: accountId});
    trackPageView({ location: window.location });
}

export const setFullStory = authResult => {
    setFullStoryUserValues({
        "internal": get(authResult,"idTokenPayload['http://cloud.netapp.com/internal']"),
        "isNetappDomain": get(authResult, 'idTokenPayload["http://cloud.netapp.com/user_metadata"].email','').toLowerCase().endsWith("netapp.com"),
        "userId": get(authResult, "idTokenPayload.sub", "")
    })
}

export const setFullStoryUserValues = (values) => {
    try{
        window["FS"].setUserVars(values);
    } catch(e) {
        console.log("Failed to set full story values");
        console.log(values);
        console.log(e);
    }

}
